<template>
  <div class="left-side" v-if="empty && profile">
    <div class="page-header">
      <h1 class="m-n text-u-c title-font">Opening hours</h1>
    </div>
    <div class="m-b-md">
      <div class="p-b-md">
        <div
          class="block text-font"
          v-for="hour in hours"
          :key="hour.day"
        >
					<span>{{ hour.day }}</span>
					<span class="pull-right">{{ hour.start }}-{{ hour.end }}</span>

				</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    empty() {
      if (this.$store.getters.profile) {
        return this.$store.getters.profile.corporateProfile.business_hours
          ? this.$store.getters.profile.corporateProfile.business_hours.length >
              0
          : false
      } else return false
    },
    hours() {
      return this.$store.getters.profile.corporateProfile.business_hours
    },
    profile() {
      return this.$store.getters.profile
    }
  }
}
</script>
<style lang="scss" scoped>
@media only screen and (min-width: 1200px) {
  .left-side .page-header {
    padding-bottom: 20px;
  }
  .title-font {
    font-weight: 300;
    font-size: 20px;
    line-height: 20px;
    color: #000;
  }
  .text-font {
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    color: #000;
  }
  .page-header {
    margin: 0px;
  }
  .row {
    margin: 0px;
  }
}
@media only screen and (max-width: 1199px) and (min-width: 768px) {
  .left-side .page-header {
    padding-bottom: 20px;
  }
  .title-font {
    font-weight: 300;
    font-size: 18px;
    line-height: 18px;
    color: #000;
  }
  .text-font {
    font-weight: normal;
    font-size: 11px;
    line-height: 13px;
    letter-spacing: 0.33px;
    color: #000;
  }
  .page-header {
    margin: 0px;
  }
  .row {
    margin: 0px;
  }
}
@media only screen and (max-width: 767px) {
  .left-side {
    padding-left: 20px;
  }
  .left-side .page-header {
    padding-bottom: 20px;
  }
  .title-font {
    font-weight: 300;
    font-size: 20px;
    line-height: 20px;
    color: #000;
  }
  .text-font {
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 0.42px;
    color: #000;
  }
  .page-header {
    margin: 0px;
  }
  .row {
    margin: 0px;
  }
}
</style>
